import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
let AflaCommonService = class AflaCommonService {
    branding;
    constructor() { }
    setThemeColors(branding) {
        this.branding = branding;
    }
    static ctorParameters = () => [];
};
AflaCommonService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], AflaCommonService);
export { AflaCommonService };
